import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, Grid, IconButton, Typography } from "@mui/material";
import WorklistSettings from "../../organisms/CollectionSettings";
import { CollectionsDashboard } from "../../organisms/CollectionsDashboard";
import { ProfileForm } from "../../organisms/ProfileForm";
import cancel from "../../../../public/assets/icons/cancel.svg";

// The grid defaults to a share of the viewport, which overflows this dialog at any
// viewport under ~963px. 289px is the dialog's own inset (64) plus its header (76),
// the tabs and search row above the grid (129), and the content's bottom padding (20).
const GRID_HEIGHT = "max(240px, calc(100vh - 289px))";

export const MANAGE_QUEUES_MODAL_TITLE = "Manage Queues";

const TITLE_ID = "manage-queues-modal-title";

interface IProps {
    isOpen: boolean;
    onClose: () => void;
    client: any;
    enableQueueViews?: boolean;
}

/** The same body QueueSettingsDrawer renders; only the chrome differs. */
const QueueSettingsModal: React.FC<IProps> = ({ isOpen, onClose, client, enableQueueViews = false }) => {
    const [showDetails, setShowDetails] = useState(false);
    const [directoryType, setDirectoryType] = useState("collection");
    const [selected, setSelected] = useState({});

    // The modal stays mounted while it is closed, so without this a reopen lands on whatever
    // profile form the previous visit left behind.
    useEffect(() => {
        if (isOpen) return;
        setShowDetails(false);
        setDirectoryType("collection");
        setSelected({});
    }, [isOpen]);

    const showForm = (profile: any, show: boolean) => {
        setSelected(profile);
        setShowDetails(show);
    };

    const queueProfile = () => (
        <>
            {showDetails ? (
                <ProfileForm
                    client={client}
                    showForm={showForm}
                    existingProfile={selected}
                    enableQueueViews={enableQueueViews}
                />
            ) : (
                <WorklistSettings
                    DirectoryType={directoryType}
                    client={client}
                    showForm={showForm}
                    gridHeight={GRID_HEIGHT}
                />
            )}
        </>
    );

    const workerCollection = () => (
        <WorklistSettings
            DirectoryType={directoryType}
            client={client}
            setShowDetails={setShowDetails}
            gridHeight={GRID_HEIGHT}
        />
    );

    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            maxWidth={false}
            aria-labelledby={TITLE_ID}
            PaperProps={{
                sx: {
                    width: "calc(100% - 40px)",
                    maxWidth: "none",
                    m: "20px",
                    borderRadius: "8px",
                },
            }}
        >
            <Grid container>
                <Grid item container margin={"20px"}>
                    <Grid item xs={6}>
                        <Typography variant="h2" id={TITLE_ID}>
                            {MANAGE_QUEUES_MODAL_TITLE}
                        </Typography>
                    </Grid>
                    <Grid item xs={6} display={"flex"} justifyContent={"flex-end"}>
                        <IconButton onClick={onClose} aria-label="close manage queues">
                            <img src={cancel} alt="" style={{ height: "20px" }} />
                        </IconButton>
                    </Grid>
                </Grid>
            </Grid>
            <DialogContent sx={{ px: 0, pt: 0 }}>
                <CollectionsDashboard
                    elevated={false}
                    queueProfile={queueProfile}
                    coderDistribution={workerCollection}
                    setDirectoryType={setDirectoryType}
                    showDetails={showDetails}
                    setShowDetails={setShowDetails}
                    tabs={[
                        { label: "Queues", value: "collection" },
                        { label: "Distribution", value: "distribution" },
                    ]}
                />
            </DialogContent>
        </Dialog>
    );
};

export default QueueSettingsModal;
